// extracted by mini-css-extract-plugin
module.exports = {"main-container":"XdsForm_main-container__PHkjQ","main-row":"XdsForm_main-row__4zokK","form-group":"XdsForm_form-group__s7M8_"};